import { render } from "./NotFoundView.vue?vue&type=template&id=5fd21aba"
const script = {}

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__